import React from 'react';

import { ReactProps } from '../../../typings/common-types';

import Icon, { IIcon } from './icon';

const svg = (props: ReactProps) => (
  <svg viewBox="0 0 26 26" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g fill="none" stroke="#051045">
      <rect width="9.622" height="12.829" x=".1" y=".601" fill="#FFBC00" rx=".648" transform="translate(6 7.79)" />
      <rect width="10.691" height="14.255" x=".111" y=".668" fill="#DE0000" rx=".72" transform="translate(9.032 4)" />
    </g>
  </svg>
);

const IconRedYellowCard = (props: IIcon & ReactProps) => <Icon {...props} svg={svg} />;

export default IconRedYellowCard;
